import { curry1 } from './curry1';
import { curry2 } from './curry2';
import { curry3 } from './curry3';
import { curry4 } from './curry4';
import { curry5 } from './curry5';
export function curry(fn) {
    switch (fn.length) {
        case 0: return fn;
        case 1: return curry1(fn);
        case 2: return curry2(fn);
        case 3: return curry3(fn);
        case 4: return curry4(fn);
        case 5: return curry5(fn);
        default: throw new Error("Its highly suggested that you do not write functions with more than 5 parameters.");
    }
}
//# sourceMappingURL=curry.js.map